module.exports = __webpack_public_path__ + "static/media/logo-light.8f2a8034.png";